<div
  *ngIf="ready && !visibility.isHidden && items && items.length"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
>
  <app-content-repeater [items]="items"></app-content-repeater>
</div>
